import { useMutation } from "@tanstack/react-query";

import { manifestBuilderApi } from "src/api/endpoints";
import { ToastParams } from "src/design-system/Toast/constants";
import { toastActions } from "src/design-system/Toast/utils";
import { errorMessage } from "src/utils/stringUtils";

type PromoteFlowVersionParams = {
  flowVersionId: string;
};

export const usePromoteFlowVersionToManifest = () => {
  return useMutation({
    mutationFn: async ({ flowVersionId }: PromoteFlowVersionParams) => {
      const toastId = toastActions.loading({
        title: "Promoting flow version to manifest",
        description:
          "Please wait while we promote the flow version to a manifest",
      });
      const response =
        await manifestBuilderApi.promoteFlowVersionToManifestApiV2ManifestBuilderPromotePost(
          {
            flow_version_id: flowVersionId,
          },
        );
      toastActions.dismiss(toastId);
      return response.data;
    },
    onSuccess: (data) => {
      const params: ToastParams = {
        title: "Flow promoted successfully",
        description: `Provider: ${data.provider_name} | Branch: ${data.branch_name}`,
      };
      toastActions.success(params);
    },
    onError: (error: Error) => {
      toastActions.failure({
        title: "Failed to promote flow version",
        description: errorMessage(error),
        actionText: "Contact Support",
        onActionClick: () => {
          window.open(
            "mailto:support@taktile.com",
            "_blank",
            "noopener noreferrer",
          );
        },
      });
    },
  });
};

export const useUploadManifest = () => {
  return useMutation({
    mutationFn: async ({ flowVersionId }: PromoteFlowVersionParams) => {
      const toastId = toastActions.loading({
        title: "Uploading manifest",
        description: "Please wait while we upload the manifest",
      });
      const response =
        await manifestBuilderApi.uploadManifestApiV2ManifestBuilderUploadPost({
          flow_version_id: flowVersionId,
        });
      toastActions.dismiss(toastId);
      return response.data;
    },
    onSuccess: () => {
      const params: ToastParams = {
        title: "Manifest uploaded successfully",
      };
      toastActions.success(params);
    },
    onError: (error: Error) => {
      toastActions.failure({
        title: "Failed to upload manifest",
        description: errorMessage(error),
        actionText: "Contact Support",
        onActionClick: () => {
          window.open(
            "mailto:support@taktile.com",
            "_blank",
            "noopener noreferrer",
          );
        },
      });
    },
  });
};
